import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { MessageOrTaskItem } from "./MessageOrTaskItem";

class MessageOrTasksTableItem implements ITableDataSourceItem<MessageOrTaskItem> {
    public Model: MessageOrTaskItem;
    public IsSelected: boolean;
    public Name: string;

    constructor(model: MessageOrTaskItem) {
        this.Model = model;
        this.IsSelected = false;
    }
}

export { MessageOrTasksTableItem };
